<template>
  <Tooltip v-bind="{ ...props }" :getPopupContainer="getPopupContainer">
    <slot></slot>
    <template v-for="(slot, name) in $slots" #[name]="slotData">
      <slot v-if="slot" :name="name" v-bind="slotData"></slot>
    </template>
  </Tooltip>
</template>

<script lang="ts" setup>
import { Tooltip } from 'ant-design-vue';
import { tooltipProps } from 'ant-design-vue/es/tooltip/Tooltip';

const props = defineProps({
  ...tooltipProps(),
  containerId: {
    type: String,
  }
});

const getPopupContainer = function (triggerNode: HTMLElement) {
  const targetContainer = document.getElementById("render-control-panel")
  if (targetContainer) {
    return targetContainer
  } else {
    return document.body
  }
}

</script>
